import { Radio, Tooltip } from 'antd';
import FormField from 'components/FormField';
import { RadioCard } from 'components/styled/radio';
import { useAccountTypeLabel } from './AccountTable';

export interface AccountTypeFieldProps {
  seat: Assistant.SeatInfo;
  nonReceptionProcessMonthlyLimit?: number;
}

function AccountTypeField(props: AccountTypeFieldProps) {
  const {
    seat: { seatLimit, enableSeat, nonReceptionAccountNum = 0, enabledNonReceptionAccountNum },
    nonReceptionProcessMonthlyLimit = 300,
  } = props;

  const { t, accountTypeLabel } = useAccountTypeLabel();

  if (nonReceptionAccountNum === 0) {
    return null;
  }

  return (
    <FormField<Assistant.AccountType>
      name="type"
      required
      label={t('account.帐号接待买家是否限额')}
      description={t('account.限额tips', { x: nonReceptionProcessMonthlyLimit })}
    >
      {({ field: { value, onChange } }) => {
        const receptionDisabled = enableSeat >= seatLimit;
        const nonReceptionDisabled = enabledNonReceptionAccountNum >= nonReceptionAccountNum;

        return (
          <Radio.Group
            id="type"
            value={value}
            onChange={({ target: { value } }) => onChange(value)}
          >
            {receptionDisabled ? (
              <Tooltip title={t('account.可新建接待不限额坐席数为0，请先进行购买')}>
                <RadioCard value={1} disabled>
                  {accountTypeLabel[1]}
                </RadioCard>
              </Tooltip>
            ) : (
              <RadioCard value={1}>{accountTypeLabel[1]}</RadioCard>
            )}
            {nonReceptionDisabled ? (
              <Tooltip title={t('account.可新建接待限额帐号坐席数为0')}>
                <RadioCard value={2} disabled>
                  {accountTypeLabel[2]}
                </RadioCard>
              </Tooltip>
            ) : (
              <RadioCard value={2}>{accountTypeLabel[2]}</RadioCard>
            )}
          </Radio.Group>
        );
      }}
    </FormField>
  );
}

export default AccountTypeField;
